import styles from "../MobileSizeComp/MobileSize.module.scss";

export default function GiftCardCTA({AddToBag}){
    return(
        <>  
            <div className={styles.dropup_wrapper}>
                {AddToBag}
            </div>
        </>
    )
}